<div
  class="container iep-form-container"
  style="
    margin-bottom: 192px;
    margin-left: auto;
    margin-right: auto;
    width: 97%;
  "
>
  <div class="row">
    <div class="col-lg-12">
      <div class="panel panel-primary">
        <div class="panel-heading">
          <h4 id="heading" style="margin-bottom: 3px; margin-top: 5px">
            Load Inventory
          </h4>
        </div>

        <div class="panel-body">
          <div class="row" *ngIf="displayAllSiteID">
            <div class="col-lg-12">
              <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"></div>
              <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
                <mat-label class="label-input" style="margin-bottom: 3px"
                  >Select Site:</mat-label
                >
              </div>
              <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4">
                <mat-form-field>
                  <mat-select
                    id="site-id"
                    name="siteID"
                    (selectionChange)="getLoadDetails()"
                    [(ngModel)]="siteId"
                    placeholder="Select SiteID"
                    required
                  >
                    <mat-option value="">-- Select SiteID --</mat-option>
                    <mat-option
                      *ngFor="let item of sites"
                      value="{{ item.siteId }}"
                      >{{ item.siteId }}</mat-option
                    >
                  </mat-select>
                  <mat-error>This field is required.</mat-error>
                </mat-form-field>
              </div>
            </div>
          </div>

          <div
            class="row"
            style="margin-top: 1px; margin-bottom: 5px"
            *ngIf="!displayAllSiteID"
          >
            <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
              <mat-label id="site-id-text"> Site ID : </mat-label
              >{{ selectedSite }}
            </div>
          </div>

          <mat-table id="table-loads" #table [dataSource]="loadSources">
            <ng-container matColumnDef="order">
              <mat-header-cell *matHeaderCellDef> S No.</mat-header-cell>

              <mat-cell *matCellDef="let load">{{ load.order }} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="loadId">
              <mat-header-cell *matHeaderCellDef>Load Id</mat-header-cell>
              <mat-cell *matCellDef="let load">{{ load.loadId }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="name">
              <mat-header-cell *matHeaderCellDef>Load Name</mat-header-cell>
              <mat-cell *matCellDef="let load">{{ load.name }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="update">
              <mat-header-cell *matHeaderCellDef>Update</mat-header-cell>
              <mat-cell *matCellDef="let load"
                ><span
                  style="padding-right: 3px"
                  (click)="updateLoad(load.loadId)"
                >
                  <mat-icon
                    aria-hidden="false"
                    aria-label="weather icon"
                    class="bosch-ic-edit"
                    style="width: max-content"
                    fontIcon="bosch-ic-edit"
                  ></mat-icon> </span
              ></mat-cell>
            </ng-container>

            <mat-header-row
              *matHeaderRowDef="displayedColumns"
            ></mat-header-row>
            <mat-row *matRowDef="let load; columns: displayedColumns"></mat-row>
          </mat-table>

          <mat-paginator
            #paginator
            [pageSize]="10"
            [pageSizeOptions]="[10, 20, 30]"
          >
          </mat-paginator>
        </div>
      </div>
    </div>
  </div>
</div>
